<!--suppress TypeScriptUnresolvedVariable -->
<div class="perm-admin-connectors-container" *ngIf="connectors">
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16 mb-24">
        <div *ngIf="connectors.length">
            <mat-select [placeholder]="'Connectors'|i18n"
                        [value]="connector"
                        (selectionChange)="onSelectConnector($event)">
                <mat-select-trigger *ngIf="connector">
                    <ng-container *ngTemplateOutlet="connectorName; context: {conn: connector}">
                    </ng-container>
                </mat-select-trigger>
                <mat-option *ngFor="let conn of connectors" [value]="conn">
                    <ng-container *ngTemplateOutlet="connectorName; context: {conn: conn}">
                    </ng-container>
                </mat-option>
            </mat-select>
        </div>
        <div *ngIf="!connectors.length">
            {{'No assignable connectors'|i18n}}
        </div>
    </div>
    <ng-container *ngIf="connector; else noConnectorSelected">
        <div fxLayout="row" fxLayoutAlign="end" class="mb-16">
            <button mat-stroked-button color="primary" class="new-assignment-button"
                    (click)="onClickNewAssignment()">
                <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
                {{'New assignment'|i18n}}
            </button>
        </div>
        <div *ngIf="assignments; else loadingAssignments">
            <app-permission-assignments [readOnly]="false"
                                        [reactiveSubject]="true"
                                        [hideObject]="true"
                                        [assignments]="assignments"
                                        (subjectClick)="onClickSubjectAssignments($event)">
            </app-permission-assignments>
        </div>
    </ng-container>
</div>

<ng-template #subjectAssignments let-data>
    <h1 mat-dialog-title *ngIf="data.hint">{{'Permission assignments for {0}'|i18n:data.hint}}</h1>
    <div mat-dialog-content fxLayout="column">
        <app-subject-permissions [subject]="[data.subjectType, data.subjectId]">
        </app-subject-permissions>
    </div>
</ng-template>

<ng-template #newAssignment let-data>
    <h1 mat-dialog-title>{{'New permission assignment on {0}'|i18n:data.object.hint}}</h1>
    <div mat-dialog-content fxLayout="column">
        <app-new-permission-assignment [subjectType]="data.subjectType"
                                       [object]="data.object"
                                       (assignment)="data.assignment = $event"
                                       (valid)="data.valid = $event"
                                       (dirty)="data.dirty = $event">
        </app-new-permission-assignment>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary"
                [disabled]="!data.valid || !data.dirty"
                [mat-dialog-close]="data.assignment">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #connectorName let-connector="conn">
    <span *ngIf="connector.id">{{connector.id}}</span>
    <span *ngIf="!connector.id">
        <app-icon name="fal-plug"></app-icon>&nbsp;&nbsp;
        {{'All connectors'|i18n}}
    </span>
</ng-template>

<ng-template #loadingAssignments>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24 mb-16">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading permission assignments'|i18n}}...</span>
    </div>
</ng-template>

<ng-template #noConnectorSelected>
    <div *ngIf="connectors.length" fxLayout="row" fxLayoutAlign="center" class="mt-16">
        <span>{{'Start by selecting a connector'|i18n}}</span>
    </div>
</ng-template>
